import { memo } from 'react';
import { Text, type TextT } from '@mentimeter/ragnar-ui/text';

interface FlexibleTextT extends Omit<TextT, 'fontSize'> {
  fontOffset: number;
  fontSize: number;
}

/**
 * Legacy component that used to do much more, now it only offsets the font size
 */
export const FlexibleText = memo<FlexibleTextT>(
  ({ fontSize, fontOffset, ...props }: FlexibleTextT) => {
    return <Text fontSize={fontSize + fontOffset} {...props} />;
  },
);
